import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoftDrinksBottle = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n            .cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "soft-drinks-bottle" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M10.511,3.755l-.092.875a8.443,8.443,0,0,1-1.347,3.8L8.29,9.75a6.991,6.991,0,0,0-.343,5.861c.7,1.865-.088,4.209-.45,5.806A1.5,1.5,0,0,0,8.96,23.25h6a1.5,1.5,0,0,0,1.462-1.833c-.361-1.6-1.069-3.941-.369-5.806A6.991,6.991,0,0,0,15.71,9.75l-.782-1.316a8.443,8.443,0,0,1-1.347-3.8l-.092-.88"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 8.96,
			y: .75,
			width: 6,
			height: 3,
			rx: 1,
			ry: 1
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 9.191,
			y1: 8.25,
			x2: 14.809,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M13.085,11.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M13.085,16.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M10.835,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M11.585,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		})
	]
});
export default SvgSoftDrinksBottle;
